import "./App.css";
import { Routes, Route } from "react-router-dom";
// import AuthProtect from "./protected_routes/AuthProtect";
import Login from "./components/login/Login";
import Otp from "./components/otp/Otp";
import Layout from "./components/Layout";
import Dashboard from "./components/dashboard/Dashboard";
import MobileAppPrompt from "./components/mobile-app-prompt/MobileAppPrompt";
import CreateAccount from "./components/create-account/CreateAccount";

function App() {
  return (
    <>
      {/* Global mobile-app prompt (appears across all routes) */}
      <MobileAppPrompt
        androidPackage="YOUR_ANDROID_PACKAGE_NAME"
        iosAppId="YOUR_IOS_APP_ID"
        deepLink="yourappscheme://"
        minWidth={900}
        dismissDurationDays={30}
      />

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route
          path="/otp"
          element={
            // <AuthProtect>
            <Otp />
            // </AuthProtect>
          }
        />
        {/* Protected Routes (with sidebar & navbar) */}
        <Route
          path="/dashboard"
          element={
            <Layout title="Dashboard" subtitle="Welcome back, Abhinav">
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/investments"
          element={
            <Layout title="Investments" subtitle="Manage your investments">
              <div>Investments Page</div>
            </Layout>
          }
        />
        <Route
          path="/portfolio"
          element={
            <Layout title="Portfolio" subtitle="View your portfolio">
              <div>Portfolio Page</div>
            </Layout>
          }
        />
        <Route
          path="/service-catalogue"
          element={
            <Layout title="Service Catalogue" subtitle="Explore our services">
              <div>Service Catalogue Page</div>
            </Layout>
          }
        />
        <Route
          path="/transactions"
          element={
            <Layout title="Transactions" subtitle="View transaction history">
              <div>Transactions Page</div>
            </Layout>
          }
        />
        <Route
          path="/learning"
          element={
            <Layout title="Learning" subtitle="Educational resources">
              <div>Learning Page</div>
            </Layout>
          }
        />
        <Route
          path="/settings"
          element={
            <Layout title="Settings" subtitle="Manage your preferences">
              <div>Settings Page</div>
            </Layout>
          }
        />
      </Routes>
    </>
  );
}

export default App;
